// extracted by mini-css-extract-plugin
export default {"wrapper":"empty_wrapper__ngX9a","image":"empty_image__rXyoW","image2":"empty_image2__Mn4uu","message":"empty_message__JyIP5","btn":"empty_btn__ikDuK"};